<template>
    <v-tabs v-model="mobileTabs" fixed-tabs class="sticky-bar">
        <v-tab>
            {{ $t('booking') }}
        </v-tab>
        <v-tab>
            {{ $t('summary') }}
        </v-tab>
    </v-tabs>
</template>

<script lang="ts">
    import {Component, VModel, Vue, Watch} from 'vue-facing-decorator'

    @Component
    export class MobileBookingPageTabs extends Vue {
        @VModel({default: 0}) mobileTabs

        @Watch('mobileTabs')
        onChangeMobileTabs(val) {
            this.$emit('change', val)
        }
    }

    export default MobileBookingPageTabs
</script>
